export default __webpack_public_path__ + "static/media/shashlik.22af42ed.jpg";